import { SectionTitle } from '@/components/Layout/SectionTitle';
import clsx from 'clsx';
import React from 'react';

interface RequestSectionProps {
	title?: string;
	children: React.ReactNode;
	bodyClassName?: string;
	className?: string;
}

const RequestSection = ({ title, children, bodyClassName, className }: RequestSectionProps) => {
  return (
    <div className={clsx('mb-5', className)}>
      <SectionTitle title={title} />
      <div className={clsx('p-3', bodyClassName)}>{children}</div>
    </div>
  );
};

export { RequestSection as default };
